const requests = {
    diagrams: `/v1/playground-templates`,
    sendFeedback: `/v1/feedback`,
};

export default requests;
